import React from 'react';
import './landing.css';

export type PaymentProvider = 'stripe' | 'hitpay';

export interface AdhocPaymentMethodButtonsProps {
  paying: boolean;
  onPay: (provider: PaymentProvider) => void;
  className?: string;
}

const AdhocPaymentMethodButtons: React.FC<AdhocPaymentMethodButtonsProps> = ({
  paying,
  onPay,
  className = 'family-pack-checkout-row family-pack-checkout-options',
}) => (
  <div className={className}>
    <button
      type="button"
      className="btn family-pack-checkout-btn family-pack-checkout-btn-stripe"
      disabled={paying}
      aria-label={paying ? 'Redirecting to Stripe checkout' : 'Pay with Stripe'}
      onClick={() => onPay('stripe')}
    >
      <span className="family-pack-checkout-btn-inner">
        {paying ? (
          'Redirecting…'
        ) : (
          <>
            Pay with{' '}
            <span className="family-pack-pay-brand">Stripe</span>
          </>
        )}
      </span>
    </button>
    <button
      type="button"
      className="btn family-pack-checkout-btn family-pack-checkout-btn-hitpay"
      disabled={paying}
      aria-label={paying ? 'Redirecting to HitPay checkout' : 'Pay with HitPay'}
      onClick={() => onPay('hitpay')}
    >
      <span className="family-pack-checkout-btn-inner">
        {paying ? (
          'Redirecting…'
        ) : (
          <>
            Pay with{' '}
            <span className="family-pack-pay-brand">HitPay</span>
          </>
        )}
      </span>
    </button>
  </div>
);

export default AdhocPaymentMethodButtons;
